export const techopsSupportConfig = {
  englishGroup: {
    link: 'https://t.me/BybitAPI',
    text: 'Telegram API英文群',
    i18n: 'techopsSupportEnglishGroup',
  },
  chineseGroup: {
    link: 'https://t.me/BybitChineseAPI',
    text: 'Telegram API中文群',
    i18n: 'techopsSupportChineseGroup',
  },
};
